import { call, put, select } from 'typed-redux-saga'
import { AnyAction } from 'redux'

import services from '@services'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { ApplicationState } from '@store/types'
import { StepRefin } from '@utils/enums'

import { enderecoError, enderecoLoading, enderecoRequest, enderecoSuccess } from '../actions'
import { Endereco, EnderecoPayload } from '../types'

const enderecoBuild = (data: Endereco) =>
  data && {
    cep: data.cep,
    tipoLogradouro: data.tipoLogradouro,
    logradouro: data.logradouro,
    bairro: data.bairro,
    uf: data.uf,
    cidade: data.cidade,
  }

export default function* getEnderecoSaga(action: AnyAction) {
  const payload = action.payload as EnderecoPayload
  const { accessToken } = yield* select((state: ApplicationState) => state.session)
  try {
    yield put(enderecoLoading())
    const responseEndereco = yield* call(services.getEnderecoService, payload.cep, accessToken)
    yield put(setLastServiceResponse({ code: 'OK', serviceName: 'getEnderecoService' }))
    const endereco = enderecoBuild(responseEndereco.data)
    yield put(enderecoSuccess())

    if (payload.callback) {
      yield payload.callback(endereco)
    }
  } catch (error) {
    yield put(setLastServiceResponse({ code: 'ERROR', serviceName: 'getEnderecoService' }))
    yield put(enderecoError())
    yield put(
      showError({
        title: 'Erro ao buscar o endereço',
        message: 'Ocorreu um erro na busca do endereço.',
        actionTitle: 'Tentar Novamente',
        code: StepRefin.ERRO_BUSCAR_ENDERECO,
        actionCallback: () => enderecoRequest(payload),
      }),
    )
  }
}
